import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(root)/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderBottomMobile","MainPageContent"] */ "/app/src/components/index.ts");
